import React from 'react';

const WhyChooseGoNextMakerTutoring = () => {
  // Données dynamiques pour les cartes
  const features = [
    {
      id: 1,
      icon: "🎓",
      title: "Tuteurs d’élite",
      description: " Experts issus du réseau FabLabs et des meilleures universités du monde (MIT, Stanford, CentraleSupélec…)."
    },
    {
      id: 2,
      icon: "🛠️",
      title: "Accompagnement sur-mesure",
      description: "Plan personnalisé adapté à vos objectifs (certification, projet personnel, montée en compétence)."
    },
    {
      id: 3,
      icon: "🌍",
      title: "Passerelle mondiale",
      description: "Intégrez un réseau international de makers, innovateurs et certifiés."
    }
  ];

  return (
    <section className="py-12 md:py-16 lg:py-24 bg-light-5">
      <div className="container mx-auto px-4">
        <div className="flex justify-center text-center mb-12">
          <div className="max-w-2xl mx-auto">
            <h2 className="text-3xl md:text-title font-bold text-dark-1 mb-4">Pourquoi choisir le Tutorat GoNextMaker ?</h2>
            <p className="text-subtitle text-gray-600">Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod.</p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {features.map((feature) => (
            <div key={feature.id} className="flex flex-col items-center text-center p-6 rounded-lg group">
              <div className="flex items-center text-3xl justify-center w-28 h-28 bg-white rounded-full shadow-sm mb-6
              group-hover:bg-purple-1 transition-colors duration-300">
                {feature.icon}
              </div>
              
              <div className="flex-1">
                <h3 className="text-subtitle font-semibold text-dark-1 mb-3">{feature.title}</h3>
                <p className="text-gray-600 text-normal">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseGoNextMakerTutoring;